module.exports = __webpack_public_path__ + "img/brink_slide_1.c59f86e0.jpg";